import { useUsersStore, useSettingsStore } from 'src/stores/index.js'

const colors = [
  '#508CD2', '#54AC54', '#B8353D', '#715CC5', '#E65528', '#FFCA3A', '#00AEE8', '#E24591', '#03440C', '#8EACE1',
  '#00C9AF', '#839000', '#74004B', '#005493', '#32021F', '#798897', '#8B5E62', '#AA68C6', '#B4654A', '#171EC7'
]
const daysOfWeek = {
  monday: 'lunes',
  tuesday: 'martes',
  wednesday: 'miércoles',
  thursday: 'jueves',
  friday: 'viernes',
  saturday: 'sábado',
  sunday: 'domingo'
}

export default {
  EVENTS: state => state.events,
  getAllEvents: state => state.events.concat(state.tasks),
  colors: () => colors,
  getEventById: (state) => (id) => state.events.find(event => event.id === id),
  groupEvents: (state) => {
    const usersStore = useUsersStore()
    if (!usersStore.current) return []
    const selectedUsersIds = state.selectedUsers.map(user => user.id)
    selectedUsersIds.push(usersStore.current.id)
    const regularEvents = state.getAllEvents.filter(event => !event.event_id)
    const correctEvents = [...regularEvents]
    const routineEvents = state.getAllEvents.filter(event => event.event_id)
    const eventIds = routineEvents.map(event => event.event_id)
    const reducedIds = eventIds.filter((id, index) => eventIds.indexOf(id) === index)

    selectedUsersIds.forEach(userId => {
      const eventsByUser = routineEvents.filter(event => event.assigned_to === userId)
      reducedIds.forEach((id) => {
        const eventsById = eventsByUser.filter(event => event.event_id === id)
        const uniqueEndDates = [...new Set(eventsById.map(event => event.end_date))]
        uniqueEndDates.forEach(endDate => {
          const events = eventsById.filter(event => event.end_date === endDate)
          if (events.length === 1) {
            correctEvents.push({ ...events[0] })
            return
          }
          const baseEvent = events[0]
          correctEvents.push({ ...baseEvent, groupBy: true, events })
        })
      })
    })
    return correctEvents
  },
  getUserColor: (state) => (event) => {
    const usersStore = useUsersStore()
    const settingsStore = useSettingsStore()

    const selectedUsers = state.selectedUsers
    const settings = settingsStore.settings

    const userColor = settings.agenda_view?.color ? settings.agenda_view.color : '#508CD2'
    if (event.triggeredBy === usersStore.current.id) return `${userColor} !important`
    const filteredColors = colors.filter(color => userColor !== color)
    const index = selectedUsers.findIndex(user => user.id === event.triggeredBy)
    return index !== -1 ? `${filteredColors[index]} !important` : '#64748B !important'
  },
  generateRecurrenceLabel: (state) => {
    if (!state.newEvent.recurrence) return ''
    const recurrence = state.newEvent.recurrence

    const selectedDays = recurrence.periodicity.map(day => daysOfWeek[day])
    const daysLabel = selectedDays.join(', ').replace(/, ([^,]*)$/, ' y $1')

    let frequencyLabel = ''
    switch (recurrence.type) {
      case 'DAILY':
        frequencyLabel = recurrence.interval > 1
          ? `cada ${recurrence.interval} días`
          : 'diariamente'
        break
      case 'WEEKLY':
        frequencyLabel = recurrence.interval > 1
          ? `cada ${recurrence.interval} semanas`
          : 'cada semana'
        break
      case 'MONTHLY':
        frequencyLabel = recurrence.interval > 1
          ? `cada ${recurrence.interval} meses`
          : 'cada mes'
        break
      case 'YEARLY':
        frequencyLabel = recurrence.interval > 1
          ? `cada ${recurrence.interval} años`
          : 'cada año'
        break
    }

    let endLabel = ''
    if (recurrence.finishType === 'after') {
      endLabel = `y terminará después de ${recurrence.recurrencesBeforeEnd} recurrencias.`
    } else if (recurrence.finishType === 'on') {
      endLabel = `y terminará el ${new Date(recurrence.endDate).toLocaleDateString()}.`
    }

    return `El evento se repetirá los ${daysLabel} ${frequencyLabel} ${endLabel}`
  },
  generateShortRecurrenceLabel: (state) => {
    if (!state.newEvent.recurrence) return ''
    const recurrence = state.newEvent.recurrence

    const selectedDays = recurrence.periodicity.map(day => daysOfWeek[day])
    const daysLabel = selectedDays.join(', ').replace(/, ([^,]*)$/, ' y $1')

    let frequencyLabel = ''

    switch (recurrence.type) {
      case 'DAILY':
        frequencyLabel = recurrence.interval > 1
          ? `${recurrence.interval} días`
          : 'diariamente'
        break
      case 'WEEKLY':
        frequencyLabel = recurrence.interval > 1
          ? `${recurrence.interval} semanas`
          : 'semana'
        break
      case 'MONTHLY':
        frequencyLabel = recurrence.interval > 1
          ? `${recurrence.interval} meses`
          : 'mes'
        break
      case 'YEARLY':
        frequencyLabel = recurrence.interval > 1
          ? `${recurrence.interval} años`
          : 'año'
        break
    }

    return `Cada ${frequencyLabel} los ${daysLabel}`
  }
}
